/**
 * This file is the main entry point for the entire app.
 *
 * If the application is being bundled, this is where the bundling process
 * starts.  If the application is being loaded by an es6 module loader, this
 * is the entry point.
 *
 * Point Webpack or SystemJS to this file.
 *
 * This module imports all the different parts of the application:
 * - 3rd party Libraries and app core module
 * - Services
 * - Components
 * - Submodules
 * - Top-level states
 * - UI-Router Transition Hooks
 */

/* globals ENV_CONFIG:false */

// Import the core app module
import { app } from "./core";

// Ensure register the app wide cache at the very first
// since it's already used within the config phase.
import "../app.cache";

// Import the components that make up the main subsections of the application
// Each submodule registers its own states/services/components
import "../app";
import "../common/config/config";
import "../common/data/data";
import "../common/directives/directives";
import "../common/domain/accountValidation";
import "../common/tracking/sentry";
import "../common/tracking/tracking";
import "../components/changelog/changelog";
import "../components/finish/finish";
import "../components/legal/legal";
import "../components/newPortfolio/newPortfolio";
import "../components/oldPortfolio/oldPortfolio";
import "../components/overview/overview";
import "../components/owner/owner";
import "../components/start/start";
import "../components/consorsUserInit/consorsUserInit";
import "../components/status/status";
import "../components/switchNotAllowed/switchNotAllowed";
import "../components/transfer/transfer";

import { fetchConfig } from "../common/config/config";
import { loadTranslations, loadTheme, loadPlausible } from "./loadCustoms";

// Base Controller Service
import { ControllerService } from "../common/base/controller.service";
app.service("controllerService", ControllerService);

fetchConfig().then((resp) => {
	const config = resp.data;
	const { theme, tenant } = config;

	loadTheme(theme, tenant, () => {
		angular.bootstrap(document, [app.name]);
	});

	app.config(($qProvider, $translatePartialLoaderProvider) => {
		// Dont throw error when promise errors are not handled
		$qProvider.errorOnUnhandledRejections(false);

		loadTranslations(config, $translatePartialLoaderProvider);
	});

	app.run(($log, configService, envService, $document, $window) => {
		"ngInject";
		loadPlausible($document, $window, configService, envService);
		configService.storeConfig(config);
		$log.info(`build ${envService.build} on ${envService.getStage()} stage`);
	});
});



// WEBPACK FOOTER //
// ./src/app/bootstrap/bootstrap.js